import { Injectable, inject, signal } from '@angular/core';
import { Observable, catchError, of, tap } from 'rxjs';
import { ApiClientService } from '../api-client.service';

export interface AppVersion {
  version: string;
  buildDate: string;
  environment: string;
}

@Injectable({ providedIn: 'root' })
export class VersionService {
  private api = inject(ApiClientService);

  readonly version = signal<string>('');
  readonly buildDate = signal<string>('');

  loadVersion(): Observable<AppVersion | null> {
    return this.api.get<AppVersion>('/version').pipe(
      tap(v => {
        this.version.set(v.version);
        this.buildDate.set(v.buildDate);
      }),
      catchError(() => of(null)),
    );
  }
}
